import StepButton from "components/Step/StepButton";
import React, {Fragment} from "react";
import StepQuestion from "components/Step/StepQuestion";
import {Col, Container, Row} from "reactstrap";
import StepLoadingComponent from "../../../../components/Step/StepLoadingComponent";

export default class WelcomeStep extends React.Component {

    render() {
        let transactionData = this.props.transactionData;
        let beneFirstName = transactionData.beneficiaryFirstName
        let senderName = transactionData.customerFirstName + " " + transactionData.customerLastName;
        let senderCountry = transactionData.countryFromDisplayValue;
        let amount = transactionData.beneficiaryAmount;

        if (!this.props.transactingPartnerConfig.REMITTANCE_PARTNER_DISPLAY_VALUE) {
            return <StepLoadingComponent/>
        } else {

            return <Fragment>
                <StepQuestion>
                    Hi {beneFirstName},
                    <br/><br/>
                    <span className={"step_bold"}>{senderName}</span> has sent&nbsp;you <span
                    className={"step_bold"}>R {amount}</span>
                    &nbsp;from <span className={"step_bold"}>{senderCountry}</span>
                    &nbsp;via {this.renderRemittancePartnerText()}.
                    <br/><br/>
                    Regulations in South Africa require that we collect some basic information from you before any money
                    can be deposited into your account.
                    <br/>
                </StepQuestion>
                <div className={"step_buttons"}>
                    <StepButton onClick={this.props.onClick}>Continue</StepButton>
                </div>

                <div className={"step_footer"}>
                    {this.renderPartnerImage()}

                    <span className={"step_footer_links"}>
                    <a href={"https://riamoney.link/about"} target={"_blank"} rel="noopener noreferrer">About</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a href={"https://riamoney.link/tncs"}
                           target={"_blank"} rel="noopener noreferrer">Terms & Conditions</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a href={"https://riamoney.link/privacy"}
                           target={"_blank"} rel="noopener noreferrer">Privacy Policy</a>
                        &nbsp;&nbsp;|&nbsp;&nbsp;
                        <a href={"https://www.riamoneytransfer.co.za"}
                           target={"_blank"} rel="noopener noreferrer">Ria Money Transfers</a>
                </span>
                </div>

            </Fragment>
        }
    }

    renderPartnerImage() {
        let inPartnerShipWith = "In partnership with:";

        return <Container>
            <Row>
                <Col xs={12} md={12}>
                    <b>{inPartnerShipWith}</b><br/>
                    {
                        this.renderPartnershipLogo(<img
                            className={"step_welcome_partner_logo"}
                            src={"/images/logo-primary-powered-by.png"} alt={"Sikhona Money Transfers"}
                        />)
                    }
                </Col>
            </Row>
        </Container>
    }

    renderPartnershipLogo(img) {
        return <Fragment>
            {img}
        </Fragment>
    }

    renderRemittancePartnerText() {
        let remittancePartnerDisplayValue = this.props.transactingPartnerConfig.REMITTANCE_PARTNER_DISPLAY_VALUE;

        if (remittancePartnerDisplayValue) {
            return <Fragment>
                {remittancePartnerDisplayValue}
            </Fragment>
        } else {
            return <Fragment>
                {this.props.remittancePartner}
            </Fragment>
        }
    }
}
